module.exports = __webpack_public_path__ + "img/picto-undraw-4.4a30a7b0.svg";